import { faFolder as faFolderRegular } from '@fortawesome/pro-regular-svg-icons';
import { faFolder as faFolderSolid } from '@fortawesome/pro-solid-svg-icons';
import cn from 'classnames';
import React, { FCC } from 'react';
import { Icon } from '../';
import './GridFolder.scss';
import { IDataGridFolderProps } from './types';

export const GridFolder: FCC<IDataGridFolderProps> = (props) => (
  <div
    className={cn('hlc-datagrid-folder-controls', {
      'folder-selected': props.isFolderSelected,
    })}
  >
    <Icon
      qa-id={props['qa-id']}
      title="Manage folders"
      icon={props.isFolderSelected ? faFolderSolid : faFolderRegular}
      size={'lg'}
      onClick={props.onClick}
    />
  </div>
);
